export const SYMPTOMATIC_2_QUESTION = {
  头面斑: '您的面部是否有色斑？',
  面色晦暗: '您是否面色暗淡无光？',
  唇暗: '您是否唇色偏暗？',
  皮下瘀血: '您是否身上有淤青？',
  身痛: '您是否经常全身疼痛？',
  记忆力差: '您是否感觉记忆力差？',
  畏寒: '您是否比较怕冷？',
  四肢冰冷: '您是否经常感觉手脚冰冷？',
  喜好热饮: '您是否更偏爱热饮？',
  腹泻: '您是否容易拉肚子？',
  易感冒: '您是否容易感冒？',
  颧红: '您是否面颊泛红？',
  目涩: '您是否常感觉眼睛干涩？',
  口干: '您是否感觉口腔干涩？',
  全身皮肤干燥: '您是否全身皮肤干燥？',
  便硬: '您是否大便偏硬？',
  手足心热: '您是否感觉手心与脚心发热？',
  口渴: '您是否经常感觉口渴？',
  口臭: '您是否有口臭？',
  牙龈红肿: '您是否牙龈红肿？',
  鼻衄: '您是否容易流鼻血？',
  痤疮: '您是否容易长痘痘？',
  出汗: '您是否较爱出汗？',
  便秘: '您是否经常便秘？',
  急躁易怒: '您是否容易急躁生气？',
  口黏: '您是否感觉口中黏腻？',
  口苦: '您是否感觉口中苦涩？',
  便粘: '您是否大便偏粘稠？',
  阴囊潮湿: '您是否阴囊部多汗、潮湿？',
  白带色黄: '您是否白带颜色偏黄？',
  全身沉重: '您是否经常全身无力沉重？',
  眼睑浮肿: '您是否眼皮浮肿？',
  唾液粘稠: '您是否口水偏粘稠？',
  胸闷: '您是否感觉胸闷？',
  腹胀: '您是否经常腹胀的？',
  腹部膨隆: '您是否有腹部膨隆症状？',
  疲倦: '您是否感觉容易疲倦？',
  沉默寡言: '您是否比较沉默寡言？',
  声低: '您是否只能低声讲话？',
  短气: '您是否呼吸比较短促？',
  心悸: '您是否感觉心慌或心跳加速？',
  头晕: '您是否感觉头晕？',
  虚汗: '您是否轻微运动就容易出汗？',
  目前无异常: '您是否目前无身体异常？',
  爪甲淡白: '您是否指甲颜色发白？',
  唇淡: '您是否唇色发白？',
  目眩: '您是否经常感觉眼花？',
  眼睑淡白: '您是否眼睑内发白？',
};
